import type { ReactNode } from 'react';
import { CheckOverCircle } from 'assets/icons';
import styles from './BenefitList.module.css';

export type BenefitListProps = {
  title?: ReactNode;
  items: ReactNode[];
  className?: string;
};

export const BenefitList = ({
  title = 'Benefits',
  items,
  className,
}: BenefitListProps) => {
  if (!items?.length) return null;

  return (
    <div className={className ? `${styles.wrapper} ${className}` : styles.wrapper}>
      <hr className={styles.divider} />
      <div className={styles.container}>
        {title ? <h3 className={styles.title}>{title}</h3> : null}
        <ul className={styles.list}>
          {items.map((item, idx) => (
            <li className={styles.item} key={idx}>
              <CheckOverCircle />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
      {/* <hr className={styles.divider} /> */}
    </div>
  );
};
